export default __webpack_public_path__ + "static/media/image_computer-home-page.4c200a57.svg";